import LenderProfile from './LenderProfile';

export default LenderProfile;
